import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-inline-alert',
	templateUrl: './inline-alert.component.html',
	styleUrls: ['./inline-alert.component.scss'],
	standalone: false,
})
export class InlineAlertComponent {
	@Input() type: 'error' | 'success' = 'success';
	@Input() message: string;
}
